import React from "react";

import {cn} from "@/utils/utils.ts";
import LinkWithGaTracking from "@/app/components/ui/link-with-ga-tracking.tsx";
import {NEXT_PUBLIC_SIGNUP_URL} from "@/config/urls.ts";

export const SignupButton = (
    {
        variant,
        className
    }: {
        variant?: "default" | "homepage" | "homepageSimple",
        className?: string
    }
) => {
    return (
        <LinkWithGaTracking
            // href={process.env.NEXT_PUBLIC_REGISTRATION_SURVEY_URL ?? NEXT_PUBLIC_REGISTRATION_SURVEY_URL}
            href={process.env.NEXT_PUBLIC_SIGNUP_URL ?? NEXT_PUBLIC_SIGNUP_URL}
            target="_blank"
            variant={variant}
            size="sm"
            className={cn("rounded-[8px] text-nowrap", className)}
            linkText="Start for free"
            labelLocation="homepage"
        />
    )
};